/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_SupersetInputs */

const en_us2_offline_kind_plan_superset = /** @type {(inputs: Offline_Kind_Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset in the plan`)
};

const pt_br2_offline_kind_plan_superset = /** @type {(inputs: Offline_Kind_Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset no plano`)
};

const es_419_offline_kind_plan_superset = /** @type {(inputs: Offline_Kind_Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superserie en el plan`)
};

const pt_pt2_offline_kind_plan_superset = /** @type {(inputs: Offline_Kind_Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset no plano`)
};

const fr_fr2_offline_kind_plan_superset = /** @type {(inputs: Offline_Kind_Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset dans le programme`)
};

const de_de2_offline_kind_plan_superset = /** @type {(inputs: Offline_Kind_Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supersatz im Plan`)
};

const it_it2_offline_kind_plan_superset = /** @type {(inputs: Offline_Kind_Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superserie nella scheda`)
};

/**
* | output |
* | --- |
* | "Superset in the plan" |
*
* @param {Offline_Kind_Plan_SupersetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_superset = /** @type {((inputs?: Offline_Kind_Plan_SupersetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_SupersetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_superset(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_superset(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_superset(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_superset(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_superset(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_superset(inputs)
	return en_us2_offline_kind_plan_superset(inputs)
});
export { offline_kind_plan_superset as "offline.kind_plan_superset" }